module.exports = __webpack_public_path__ + "static/img/09.4ce274d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/09.jpg
// module id = AdKQ
// module chunks = 0